/**
 * Pure derivations over a licence credit ledger. Extracted from the Credits tab's
 * `useMemo`s so they can be unit-tested without React; the selectors memoise them.
 */

import type { BalancePoint, CreditEvent } from './credit-ledger.model';

/**
 * Running balance per movement. Events arrive ascending by `created_at`, so the
 * balance after each point is the cumulative sum of the signed deltas. The date is
 * left as the raw ISO string: formatting is a presentation concern.
 */
export function buildBalanceSeries(events: CreditEvent[]): BalancePoint[] {
  let running = 0;
  return events.map((e) => {
    running += e.delta;
    return { date: e.created_at, balance: running };
  });
}

/** Most recent first; the order the movements table displays. */
export function sortEventsDesc(events: CreditEvent[]): CreditEvent[] {
  return [...events].reverse();
}
